<template>
  <div class="col-md-12">
    <ConsulteGrid
      :columns="colunas"
      :data-source="dataSource"
      titulo-relatorio="Salas e ambientes"
      nome-arquivo-relatorio="Salas_ambientes"
    >
      <template #header>
        <router-link
          v-if="permissao.incluir"
          :to="{ name: 'sala_create' }"
          class="btn btn-primary rounded-pill ms-2"
        >
          <i class="uil uil-plus" aria-hidden="true"></i> Cadastrar
        </router-link>
      </template>
      <template #botaoSelecionar="{ row }">
        <router-link
          :to="{ name: 'sala_create', params: { id: row.gesSalaId } }"
          class="btn btn-sm btn-outline-secondary"
          :aria-label="`${permissao.alterar ? 'Editar' : 'Abrir'} o ambiente ${row.numero}`"
        >
          <i :class="permissao.alterar ? 'mdi mdi-pencil' : 'mdi mdi-eye'" aria-hidden="true"></i>
          <span class="ms-1">{{ permissao.alterar ? 'Editar' : 'Abrir' }}</span>
        </router-link>
      </template>
      <template #area="{ row }">{{ formatarArea(row.area) }}</template>
      <template #capacidade="{ row }">
        {{ row.capacidade ?? '' }}
        <small v-if="row.capacidadeAjusteManual" class="d-block text-muted">ajustada</small>
      </template>
      <template #ativo="{ row }">{{ row.ativo === 0 ? 'Não' : 'Sim' }}</template>
    </ConsulteGrid>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import ConsulteGrid from '@/components/grid/ConsulteGrid.vue';
  import { ConsulteGridColumnsModel } from '@/datasources/consulte-grid';
  import SalaDataSource from '@/datasources/gestao/sala/index.datasource';
  import {
    permissaoTelaLiberada,
    PERMISSAO_TELA_INJECT_KEY,
  } from '@/composables/usePermissaoTela/usePermissaoTela';

  export default defineComponent({
    name: 'SalaGridIndex',
    components: { ConsulteGrid },
    inject: { permissao: { from: PERMISSAO_TELA_INJECT_KEY, default: permissaoTelaLiberada } },
    data() {
      // Colunas calculadas depois da consulta (forma de ocupação) ou numéricas não têm filtro
      // de texto no servidor; continuam ordenáveis quando a consulta permite.
      const coluna = (text: string, datafield: string, filterable: boolean, sortable = filterable) =>
        Object.assign(new ConsulteGridColumnsModel(), {
          text,
          datafield,
          filterable,
          sortable,
          editable: false,
          filtertype: 'text',
          align: 'left',
          cellsalign: 'left',
        });

      return {
        dataSource: new SalaDataSource(0, 10, 0, 0, []),
        colunas: [
          coluna('Ações', 'botaoSelecionar', false),
          coluna('Identificação', 'numero', true),
          coluna('Localização', 'bloco', true),
          coluna('Tipo de ambiente', 'funcaoOriginalSala', true),
          coluna('Forma de ocupação', 'formaOcupacaoDescricao', false),
          coluna('Área (m²)', 'area', false, true),
          coluna('Capacidade (alunos)', 'capacidade', false, true),
          coluna('Ativo', 'ativo', false, true),
        ] as ConsulteGridColumnsModel[],
      };
    },
    methods: {
      formatarArea(area?: number | null): string {
        return area == null ? '' : area.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
      },
    },
  });
</script>
